import React, {FC} from "react";
import NcImage from "components/NcImage/NcImage";
import rightImgDemo from "images/teamcoffee.svg";
import ButtonPrimary from "components/Button/ButtonPrimary";
import ButtonSecondary from "../Button/ButtonSecondary";
import {addDoc, collection, doc, onSnapshot} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import {loadStripe} from "@stripe/stripe-js";
import {displayToast, toastType} from "../../global/Functions";

export interface SectionBuyACoffee {
    className?: string;
    rightImg?: string;
}

const SectionBuyACoffee: FC<SectionBuyACoffee> = ({className = "", rightImg = rightImgDemo}) => {

  const sendToCheckout = () => {
    if (auth.currentUser?.uid) {
      const docRef = doc(db, "users", `${auth.currentUser.uid}`);
      const checkOutRef = collection(docRef, "checkout_sessions");
      addDoc(checkOutRef, {
        mode: "payment",
        price: "price_1L1Y1oLGtlSqmT1Rv2iQTUcG", // One-time price created in Stripe
        success_url: "https://thecryptoverse.tech/dashboard",
        cancel_url: "https://thecryptoverse.tech",
      }).then((result) => {
        onSnapshot(doc(checkOutRef, result.id), async (snapshot) => {
          const sessionId = snapshot.get("sessionId");
          const error = snapshot.get("error");
          if (sessionId) {
            const stripePromise = await loadStripe("pk_live_51KiMCmLGtlSqmT1RbmE8Th0LTINMEyB6TBPl5HALgmmtSnDcgIogXxnAst45RgCWgw9i4Q2hXmmNxJlx7cuNV5Lv00xaqjGeWF");
            await stripePromise?.redirectToCheckout({sessionId});
          }
          if (error) displayToast(error.message, toastType.error);
        })
      }).catch((error) => {
        displayToast(error.message, toastType.error);
        console.log(error.message)
      })
    }
  }
  return (
    <div
      className={`nc-SectionBuyACoffee relative flex flex-col lg:flex-row items-center  ${className}`}
      data-nc-id="SectionBuyACoffee"
    >
      <div className="flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
        <span className="text-xs uppercase tracking-wider font-medium text-neutral-400">
          Thank you for being a part of our community
        </span>
        <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
          Want to support our team of founders?
        </h2>
        <span className="block mt-8 text-neutral-500 dark:text-neutral-400">
          If you love The CryptoVerse community as much as we do, please consider buying us a drink or making a small donation.
        </span>
        <div className="flex space-x-4 mt-11">
            <ButtonPrimary onClick={() => {auth.currentUser?.uid
              // Activate through firebase first
              // ? sendToCheckout()
              ? window.open("https://buy.stripe.com/9AQaEG9ZNcipcjmcMM", "_blank")
              : window.open("https://buy.stripe.com/9AQaEG9ZNcipcjmcMM", "_blank")
            }}>
              Make a Donation
            </ButtonPrimary>
          <ButtonSecondary >
            Buy A Drink
          </ButtonSecondary>
        </div>
      </div>
      <div className="flex-grow">
        <NcImage src={rightImg}/>
      </div>
    </div>
  );
};

export default SectionBuyACoffee;
